import { Modal } from 'cpool-components/general/Modal';

import { ChatsListView } from './ChatsListView';
import { ChatView } from './ChatView';
import { UserInfoPanel } from '~/features/whatsapp/components/UserInfoPanel';
import { useIsCommunicationPage } from '~/features/whatsapp/hooks/useIsCommunicationPage';
import {
    CHAT_PANEL_VIEWS,
    type ChatPanelView,
    closePanel,
    useChatPanelCurrentView,
    useChatPanelStore,
} from '~/features/whatsapp/stores/chatPanelStore';

const PANEL_WIDTH: Record<ChatPanelView, string> = {
    [CHAT_PANEL_VIEWS.CHAT]: '520px',
    [CHAT_PANEL_VIEWS.LIST]: '520px',
    [CHAT_PANEL_VIEWS.USER_INFO]: '520px',
};

export const ChatPanel = () => {
    const isCommunicationPage = useIsCommunicationPage();
    const isOpen = useChatPanelStore.use.isOpen();
    const activeChatId = useChatPanelStore.use.activeChatId();
    const view = useChatPanelCurrentView();

    // CommunicationPage renders these components inline — skip the floating modal there.
    if (isCommunicationPage) {
        return null;
    }

    return (
        <Modal variant="sidebar" side="right" width={PANEL_WIDTH[view]} open={isOpen} onClose={closePanel}>
            {/* Negative margin neutralizes Modal's fixed padding — children manage their own spacing. */}
            <div className="-m-6 flex h-[calc(100%+48px)] min-h-0 flex-col" data-testid="chat-panel">
                {view === CHAT_PANEL_VIEWS.LIST && <ChatsListView />}
                {view === CHAT_PANEL_VIEWS.CHAT && activeChatId && <ChatView chatId={activeChatId} />}
                {view === CHAT_PANEL_VIEWS.USER_INFO && activeChatId && <UserInfoPanel chatId={activeChatId} />}
            </div>
        </Modal>
    );
};
